import { getAPI, patchAPI, postAPI } from "../../../api/Networking";
import { PaginatedAPIResponse } from "../../../models/NetworkResponse";
import {
  SampleSirActivityEntry,
  StockIssueRequest,
} from "../../../models/StockIssueRequest/StockIssueRequest";
import { StockIssueRequestFilters } from "../../../models/StockIssueRequest/StockIssueRequestFilters";
import { StockIssueRequestBody } from "../../../models/StockIssueRequest/StockIssueRequestBody";

export default class StockIssueRequestAPI {
  createStockIssueRequest = async (
    body: StockIssueRequestBody,
  ): Promise<StockIssueRequest> => {
    try {
      const response = await postAPI("/v1/stock-issue-request", body);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getStockIssueRequestById = async (id: number): Promise<StockIssueRequest> => {
    try {
      const response = await getAPI(`/v1/stock-issue-request/id/${id}`);
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  getStockIssueRequestActivityLogs = async (
    id: number,
  ): Promise<SampleSirActivityEntry[]> => {
    try {
      const response = await getAPI(
        `/v1/stock-issue-request/id/${id}/activity-logs`,
      );
      return response.result?.list ?? [];
    } catch (error) {
      throw error;
    }
  };

  getStockIssueRequests = async (
    filters: StockIssueRequestFilters,
  ): Promise<PaginatedAPIResponse<StockIssueRequest>> => {
    try {
      const params = new URLSearchParams();
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== "") {
          params.set(key, value.toString());
        }
      });
      const response = await getAPI(
        `/v1/stock-issue-request?${params.toString()}`,
      );
      return response.result;
    } catch (error) {
      throw error;
    }
  };

  approveStockIssueRequest = async (id: number): Promise<void> => {
    try {
      await patchAPI(`/v1/stock-issue-request/id/${id}/approve`);
    } catch (error) {
      throw error;
    }
  };

  rejectStockIssueRequest = async (
    id: number,
    rejectionReason: string,
  ): Promise<void> => {
    try {
      await patchAPI(`/v1/stock-issue-request/id/${id}/reject`, {
        rejection_reason: rejectionReason,
      });
    } catch (error) {
      throw error;
    }
  };
}
